// extracted by mini-css-extract-plugin
export default {"messageArea":"Chat_messageArea__Y-bfs","inputForm":"Chat_inputForm__X8E6s","messageInput":"Chat_messageInput__EYGsG","sendButton":"Chat_sendButton__Fs8Pz"};